import { isProd } from './environment';
const ConsoleLogger = {
    info: (...args) => console.log(...args),
    warn: (...args) => console.warn(...args),
    error: (...args) => console.error(...args),
};
const NoopLogger = {
    info: () => { },
    warn: () => { },
    error: () => { },
};
export const log = isProd ? NoopLogger : ConsoleLogger;
